import PropTypes from "prop-types";
export var validTypeValues = ["success", "info", "warning", "error"];
export var validVariationValues = ["loud", "soft"];
export var validBackgroundValues = ["white", "light"];
export var AlertPropTypes = {
  type: PropTypes.oneOf(validTypeValues).isRequired,
  variation: PropTypes.oneOf(validVariationValues),
  background: PropTypes.oneOf(validBackgroundValues),
  title: PropTypes.node,
  children: PropTypes.node,
  fullWidth: PropTypes.bool
};